/* recs.js — ported VERBATIM from code.txt (lines 624-677). Do not edit formulas:
   plan.md §12 pins them with golden tests. */

import { toks, titleCase } from "./tokens.js";
import { STOP } from "./constants.js";

export function phraseRemainders(topic) {
  const nameToks = new Set(toks(topic.name));
  const counts = new Map();
  topic.queries.forEach(q => {
    const rem = q.query.toLowerCase().replace(/[^a-z0-9 ]/g, " ").split(/\s+/).filter(w => w && !STOP.has(w) && !nameToks.has(w));
    if (!rem.length) return;
    const phrase = rem.join(" ");
    counts.set(phrase, (counts.get(phrase) || 0) + q.impressions);
  });
  return [...counts.entries()].sort((a, b) => b[1] - a[1]).map(([p]) => titleCase(p));
}
export function questionQueries(topic) {
  const qs = topic.queries.filter(q => /^(what|how|which|are|is|can|should|do|does|why|when|will)\b/.test(q.query)).sort((a, b) => b.impressions - a.impressions).map(q => q.query.charAt(0).toUpperCase() + q.query.slice(1) + "?");
  const out = [...new Set(qs)].slice(0, 5);
  if (out.length < 3) { const low = topic.name.toLowerCase(); out.push(`What are the best ${low.replace(/^best /, "")}?`, `How do I choose ${low.replace(/^best /, "")}?`); }
  return [...new Set(out)].slice(0, 5);
}
export function buildRecs(topic, results) {
  const recs = [];
  const phrases = phraseRemainders(topic).slice(0, 5);
  const short = topic.name.replace(/^Best /, "").toLowerCase();
  if (phrases.length >= 2) recs.push({
    title: `Expand your ${short} coverage`,
    body: `Your page ranks for many ${short} searches but likely doesn't cover the topic in enough depth. Add sections covering:`,
    bullets: phrases,
  });
  const questions = questionQueries(topic);
  if (questions.length) recs.push({
    title: "Answer these questions directly on the page",
    body: "People frequently search:",
    bullets: questions,
  });
  const supporting = new Set();
  results.pages.slice(0, 80).forEach(p => { if (p.url !== topic.page && [...toks(topic.name)].some(t => t.length > 3 && p.path.includes(t)) && supporting.size < 6) supporting.add(p.path); });
  if (supporting.size) recs.push({
    title: "Strengthen related content",
    body: `You have ${supporting.size} supporting page${supporting.size > 1 ? "s" : ""} related to this topic. Link them clearly to your main page so the whole cluster is easier to understand:`,
    bullets: [...supporting].slice(0, 4),
  });
  if (results.winners.length) {
    const w = results.winners[0];
    recs.push({
      title: "Borrow patterns from your AI winners",
      body: `${w.name} already performs unusually well in AI results. Open it and compare it against this page \u2014 whatever it does differently is your best available clue (we don't crawl pages, so verify on the page itself).`,
      bullets: [],
    });
  }
  return recs.slice(0, 4);
}
